export default __webpack_public_path__ + "static/beatbugs-2-a-e3fd03b20246a28d49c581f1bfff9993.webp";